<template>
  <!-- 查看隐患-->
  <el-dialog
    title="选择督办专员"
    :visible.sync="outerVisible"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="400px"
  >
    <el-form label-width="100px" class="demo-ruleForm">
      <el-form-item label="督办专员" prop="region">
        <el-select
          v-model="req.supervisorId"
          placeholder="请选择督办专员"
          filterable
          clearable=""
        >
          <el-option
            v-for="(item, index) in personList"
            :key="index"
            :label="item.userName"
            :value="item.userId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm()">
          确定
        </el-button>
        <el-button @click="handleClose">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "HiddenDangerSuperviseDialog",
  components: {},
  props: {
    superviseResize: {
      type: Number,
      default: {
        return: 0
      }
    },
    selData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      eduInfo: JSON.parse(sessionStorage.getItem("eduInfo")),
      outerVisible: false,
      req: {
        hiddenDangerId: "",
        schoolId: "",
        supervisorId: "", // 督办人 id
        streetOfficesId: ""
      },
      personList: []
    };
  },
  created() {},
  mounted() {},
  watch: {
    superviseResize: function(newVal) {
      if (newVal) {
        this.req.hiddenDangerId = this.selData.hiddenDangerId;
        this.req.schoolId = this.selData.schoolId;
        this.req.streetOfficesId = this.selData.streetOfficesId;
        this.getSupervisePerson();
      }
    }
  },
  computed: {},
  methods: {
    handleClose() {
      this.req.supervisorId = "";
      this.outerVisible = false;
    },
    submitForm() {
      if (this.req.supervisorId == "") {
        this.$message("请选择督办人员！");
        return;
      }
      this.supervise();
    },
    // 隐患督办人员获取
    async getSupervisePerson() {
      let req = {
        eduId: this.eduInfo.eduId
      };
      let res = await this.$Http.getHiddenDangerSupervisePerson(req);
      if (res.code == 200) {
        this.outerVisible = true;
        this.personList = res.data;
      } else if (res.code == 101) {
        this.$message({
          type: "info",
          message: "请先添加人员！"
        });
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 隐患督办
    async supervise() {
      let res = await this.$Http.doHiddenDangerSupervise(this.req);
      if (res.code == 200) {
        // this.$message("已督办！");
        this.$message({
          type: "success",
          message: "已督办！"
        });
        this.handleClose();
        this.$parent.getHiddenDangerData();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
